import React, { Component } from 'react';
import { RollbarApi } from '@/integrations/Rollbar';
import { ErrorDisplayer } from '@/features/errors/ErrorDisplayer';

//
// https://reactjs.org/docs/error-boundaries.html
//
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentChild: null,
      hasError: false,
      errorId: null,
      info: null,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const child = props.children && props.children.type?.displayName;
    if (state.currentChild === child) {
      // nothing has changed
      return null;
    }
    // props have changed, so reset
    return {
      ...state,
      currentChild: child,
      hasError: false,
      errorId: null,
      info: null,
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  async componentDidCatch(error, _info) {
    const rollbar = await RollbarApi;
    const { uuid } = await rollbar.error(`[CAUGHT] ${error.message}`, error);
    this.setState({ errorId: uuid, info: error.message });
  }

  render() {
    const { children } = this.props;
    if (this.state.hasError) {
      return (
        <ErrorDisplayer
          info={this.state.info}
          rollbarErrorId={this.state.errorId}
        />
      );
    }
    if (!children) {
      return <div />;
    }
    return children; // NOTE: don't wrap in div, as this will break CSS of some components using this ErrorBoundary
  }
}

export default ErrorBoundary;
